export const GETINVENTORYLOSSPAGE = 'GETINVENTORYLOSSPAGE'
export const GETINVENTORYLOSSDETAIL = 'GETINVENTORYLOSSDETAIL'
export const INVENTORYHANDLE = 'INVENTORYHANDLE'

/**
 * 盘点任务
 */
export const GETTASKLIST = 'GETTASKLIST'
export const GETGOODS = 'GETGOODS'
export const GETSUPPLIERSELECT = 'GETSUPPLIERSELECT'
export const CRATEINVENTORYTASK = 'CRATEINVENTORYTASK'
export const GETINVENTORYTASKINFO = 'GETINVENTORYTASKINFO'
export const TAKEINVENTORYTASK = 'TAKEINVENTORYTASK'
export const CANCELINVENTORYTASK = 'CANCELINVENTORYTASK'
/**
 * 盘点计划
 */
export const GETLIQUIDATIONPLAN = 'GETLIQUIDATIONPLAN' // 获取列表
export const SAVELIQUIDATIONPLAN = 'SAVELIQUIDATIONPLAN' // 保存
export const GETLIQUIDATIONPLANDETAIL = 'GETLIQUIDATIONPLANDETAIL' // 查看详情
export const GETLOCATIONDETAIL = 'GETLOCATIONDETAIL' // 货位详情
export const GETLOCATIONGOODSDETAIL = 'GETLOCATIONGOODSDETAIL' // 商品、商品货位详情
export const ADDPLANCHECK = 'ADDPLANCHECK' // 查询是否有未完成的计划
export const CHECKTASK = 'CHECKTASK' // 验证任务是否未完成
export const GETPLANDETAIL = 'GETPLANDETAIL' // 查看详情



// WEBPACK FOOTER //
// ./src/store/liquidationManage/types.js